var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrPop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 110,
    viewBox: "0 0 256 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dr"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 175.17,
    y1: 47.44,
    x2: 105.42,
    y2: 47.44,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "104.13 94.3 104.13 25.63 97.86 23.04 84.48 23.04 79.08 25.42 79.08 59.1",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "76.92 24.77 84.91 21.1 97 21.1 106.29 24.55",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "81.02 21.75 84.48 13.76 88.15 12.03 91.6 12.03",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "102.18 21.75 98.73 13.76 95.06 12.03 91.6 12.03",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.48,
    y1: 87.44,
    x2: 84.48,
    y2: 94.52,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.48,
    y1: 23.04,
    x2: 84.48,
    y2: 74,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.86,
    y1: 23.04,
    x2: 97.86,
    y2: 94.3,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.69
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "87.5 11.16 85.99 8.79 87.5 6.2 91.17 6.2",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "94.84 11.16 96.35 8.79 94.84 6.2 91.17 6.2",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,1.66h0c1.55,0,2.81,1.26,2.81,2.81v1.51h-5.61v-1.51c0-1.55,1.26-2.81,2.81-2.81Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.79,
    y: 29.95,
    width: 3.67,
    height: 7.13,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.79,
    y: 55,
    width: 3.67,
    height: 7.13,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "201.73 94.3 201.73 25.63 195.47 23.04 182.08 23.04 176.68 25.42 176.68 94.08",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "174.52 24.77 182.51 21.1 194.6 21.1 203.89 24.55",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "178.63 21.75 182.08 13.76 185.75 12.03 189.21 12.03",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "199.79 21.75 196.33 13.76 192.66 12.03 189.21 12.03",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.08,
    y1: 23.04,
    x2: 182.08,
    y2: 94.52,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.69
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.47,
    y1: 23.04,
    x2: 195.47,
    y2: 94.3,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.69
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "185.1 11.16 183.59 8.79 185.1 6.2 188.77 6.2",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "192.45 11.16 193.96 8.79 192.45 6.2 188.77 6.2",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.99,1.66h0c1.55,0,2.81,1.26,2.81,2.81v1.51h-5.61v-1.51c0-1.55,1.26-2.81,2.81-2.81Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.4,
    y: 29.95,
    width: 3.67,
    height: 7.13,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.4,
    y: 55,
    width: 3.67,
    height: 7.13,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "66.76 46.36 66.76 34.79 61.42 32.58 50 32.58 45.4 34.61 45.4 93.18",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "43.56 34.05 50.37 30.92 60.68 30.92 68.6 33.87",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "47.05 31.48 50 24.66 53.13 23.19 56.08 23.19",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "65.1 31.48 62.16 24.66 59.03 23.19 56.08 23.19",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 32.58,
    x2: 50,
    y2: 93.55,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.42,
    y1: 32.58,
    x2: 61.42,
    y2: 93.36,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.44
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "52.58 22.45 51.29 20.42 52.58 18.21 55.71 18.21",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "58.84 22.45 60.13 20.42 58.84 18.21 55.71 18.21",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9,14.35h0c1.32,0,2.39,1.07,2.39,2.39v1.29h-4.79v-1.29c0-1.32,1.07-2.39,2.39-2.39Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.69,
    y: 38.47,
    width: 3.13,
    height: 6.08,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.69,
    y: 59.84,
    width: 3.13,
    height: 6.08,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "104.13 38.59 116 28.45 153.58 28.45 176.9 39.45",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.89
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "152.71 28.45 152.71 19.34 116 19.34 116 28.45 105.21 28.45",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.89
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "78.65 48.52 57.7 53.7 78.86 36.21",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.43,
    y1: 19.34,
    x2: 116,
    y2: 19.34,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.89
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,19.34c4.7-3.38,10.87-5.83,18.57-7.31,7.71,1.41,13.64,3.92,18.14,7.31",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.74
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.45,17.92c3.01-2.06,6.72-3.6,11.14-4.6l21.98-1.29",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.75,
    y1: 94.52,
    x2: 214.25,
    y2: 94.52,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.14,
    y: 76.38,
    width: 3.02,
    height: 8.42,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.81,
    y: 76.38,
    width: 3.02,
    height: 8.42,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.49,
    y: 76.38,
    width: 3.02,
    height: 8.42,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.14,
    y: 54.57,
    width: 3.02,
    height: 8.42,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.81,
    y: 54.57,
    width: 3.02,
    height: 8.42,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.49,
    y: 54.57,
    width: 3.02,
    height: 8.42,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.56,
    y1: 67.31,
    x2: 176.68,
    y2: 67.31,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.02,
    y1: 67.57,
    x2: 61.8,
    y2: 68.39,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "61.15 69.47 49.93 69.47 45.39 70.76",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "176.68 67.31 182.3 66.44 195.47 66.23 201.51 67.31",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "200.87 49.17 195.04 47.01 181.86 47.01 177.33 48.52",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "82.64 66.69 84.26 66.44 97.43 66.23 103.48 67.31",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "102.83 49.17 97 47.01 83.83 47.01 79.29 48.52",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.12,77.79c0-6.23-5.18-14.59-6.07-14.59s-6.07,8.36-6.07,14.59,2.72,7.99,6.07,7.99,6.07-1.75,6.07-7.99Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.93,
    y1: 77.63,
    x2: 36.93,
    y2: 94.37,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.29,
    y1: 94.53,
    x2: 38.7,
    y2: 94.53,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.08,79.95c0-10.57-7.82-24.74-9.16-24.74s-9.16,14.17-9.16,24.74,4.1,13.54,9.16,13.54,9.16-2.97,9.16-13.54Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.73,
    y1: 79.69,
    x2: 75.73,
    y2: 108.08,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.25,
    y1: 108.34,
    x2: 78.41,
    y2: 108.34,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.01,79.95c0-10.57-7.82-24.74-9.16-24.74s-9.16,14.17-9.16,24.74,4.1,13.54,9.16,13.54,9.16-2.97,9.16-13.54Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.66,
    y1: 79.69,
    x2: 215.66,
    y2: 108.08,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.18,
    y1: 108.34,
    x2: 218.33,
    y2: 108.34,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrPop);
export default __webpack_public_path__ + "static/media/dr_pop.8c1a0e978ed7fca7243478ef9cf2e1c1.svg";
export { ForwardRef as ReactComponent };